module.exports = __webpack_public_path__ + "images/upgrade-prompts/pinterest.e9238b9d6fda8ebe3ccd.svg";